export { default } from "./details-section-title";
